module.exports = __webpack_public_path__ + "static/media/bira.ab1de54a.png";